import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-03ce1abc"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-label"];
const _hoisted_2 = { class: "iframe-wrapper" };
const _hoisted_3 = {
    key: 0,
    class: "rotate-phone-wrapper"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "hover-cursor--wrapper" }, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "background" }, null, -1));
import { HoverCursor } from 'hover-cursor';
import { ref, onMounted, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'showcase_hero',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const vimeoPlayer = ref(null);
        var isAudioMuted = ref(true);
        var soundState = ref('sound_on'); // This is for GA tracking
        // Track scroll position
        const scrollPosition = ref(0);
        // Calculate window height dynamically
        const windowHeight = ref(window.innerHeight);
        const isMobile = ref(false);
        const isPortrait = ref(true);
        const rotatePhone = ref(false);
        const isMobileVideo = ref(false);
        const detectDeviceOrientation = () => {
            isMobile.value = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            updatePhoneVisibility();
        };
        const updatePhoneVisibility = () => {
            rotatePhone.value = isMobile.value && isLandscape();
            isPortrait.value = !isLandscape();
        };
        const isLandscape = () => {
            return window.innerWidth > window.innerHeight;
        };
        window.addEventListener("orientationchange", function () {
            if (!window.matchMedia("(orientation: portrait)").matches) {
                // Portrait
                rotatePhone.value = true;
                isPortrait.value = true;
            }
            if (!window.matchMedia("(orientation: landscape)").matches) {
                // Landscape
                rotatePhone.value = false;
                isPortrait.value = false;
            }
        }, false);
        // Update scroll position on scroll
        window.addEventListener('scroll', () => {
            scrollPosition.value = window.scrollY;
        });
        // Update window height on resize
        window.addEventListener('resize', () => {
            windowHeight.value = window.innerHeight;
        });
        onMounted(() => {
            // Detect mobile device and portrait orientation
            detectDeviceOrientation();
            // Check if the mobile video should be used
            if (props.d.mobile_vimeo_id && window.innerWidth < 640) {
                isMobileVideo.value = true;
            }
            // Initialize the appropriate video player
            if (vimeoPlayer.value) {
                const playerId = isMobileVideo.value ? props.d.mobile_vimeo_id : props.d.vimeo_id;
                const player = new Vimeo.Player(vimeoPlayer.value, {
                    id: playerId,
                    background: 1,
                    responsive: true,
                    autoplay: true
                });
            }
            // Function to handle audio toggle
            function toggleAudio() {
                const iframe = document.getElementById('showcaseVideo').getElementsByTagName("iframe")[0];
                if (isAudioMuted.value) {
                    iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                    soundState.value = 'sound_off';
                }
                else {
                    iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                    soundState.value = 'sound_on';
                }
                isAudioMuted.value = !isAudioMuted.value;
            }
            // Initialize hover cursor functionality if enabled
            if (props.d.show_hover_cursor === 'true') {
                new HoverCursor({
                    containerQuery: '.showcase_hero',
                    snapPosition: 'R',
                    icon: '/images/sound-off.svg',
                    toggledIcon: '/images/sound-on.svg',
                    toggledFunction: toggleAudio
                });
            }
        });
        // Watch for changes in the mobile video ID and viewport width
        watch(() => props.d.mobile_vimeo_id, (newValue) => {
            if (newValue && window.innerWidth < 640) {
                isMobileVideo.value = true;
            }
            else {
                isMobileVideo.value = false;
            }
        });
        // Watch for changes in viewport width for orientation detection
        window.addEventListener('resize', detectDeviceOrientation);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "showcase_hero track-link",
                style: _normalizeStyle({ visibility: scrollPosition.value > windowHeight.value ? 'hidden' : 'visible' }),
                "data-label": _unref(soundState),
                "data-module": "showcase_hero"
            }, [
                _createElementVNode("div", _hoisted_2, [
                    (isMobile.value && isPortrait.value && __props.d.show_hover_cursor == 'true')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: "/images/rotate-icon.gif",
                                class: _normalizeClass(["rotate-phone-image", { 'rotate-animation': rotatePhone.value }]),
                                alt: "Phone Image"
                            }, null, 2)
                        ]))
                        : _createCommentVNode("", true),
                    (props.d.vimeo_id)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            ref_key: "vimeoPlayer",
                            ref: vimeoPlayer,
                            id: "showcaseVideo",
                            class: _normalizeClass({ 'mobile-video': isMobileVideo.value })
                        }, null, 2))
                        : _createCommentVNode("", true)
                ]),
                _hoisted_4,
                _hoisted_5
            ], 12, _hoisted_1));
        };
    }
});
